import * as FS from 'file-saver';

const service = {
  async saveAs(...args) {
    return FS.saveAs(...args);
  },
};

export default service;
